import { render } from "./KPISection.vue?vue&type=template&id=1e10e7bf"
import script from "./KPISection.vue?vue&type=script&lang=js"
export * from "./KPISection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__